/**
 * Diccionario i18n del shell principal del SPA (admin.js) y del componente
 * ConfirmacionDestructiva. Cubre toasts globales, login, recuperación de
 * cuenta, títulos de modal de alertas y el template del modal destructivo.
 *
 * Las claves del menú lateral (Dashboard, Juegos, Plataforma, Clientes,
 * Actividad, Finanzas, Marketing, Sistema) y los botones globales (Guardar,
 * Cancelar, Confirmar) viven en diccionario-comunes.js — no se re-declaran.
 *
 * Solo columna pt (Fase 1). Terminología pt-BR canónica del proyecto.
 */

export const DICCIONARIO_SHELL = {
    // ── Toasts globales ─────────────────────────────────────────────────────
    'Error cargando configuración': { pt: 'Erro ao carregar configuração', en: 'Error loading configuration', ru: 'Ошибка загрузки конфигурации' },
    'Valores inválidos': { pt: 'Valores inválidos', en: 'Invalid values', ru: 'Недопустимые значения' },
    'Configuración guardada': { pt: 'Configuração salva', en: 'Configuration saved', ru: 'Конфигурация сохранена' },
    'Error al copiar': { pt: 'Erro ao copiar', en: 'Error copying', ru: 'Ошибка копирования' },

    // ── Login ────────────────────────────────────────────────────────────────
    'Ingresando...': { pt: 'Entrando...', en: 'Signing in...', ru: 'Вход...' },
    Ingresar: { pt: 'Entrar', en: 'Sign in', ru: 'Войти' },
    'Error al iniciar sesión': { pt: 'Erro ao iniciar sessão', en: 'Error signing in', ru: 'Ошибка входа' },

    // ── Recuperación / activación de cuenta ─────────────────────────────────
    'Activá tu cuenta': { pt: 'Ative sua conta', en: 'Activate your account', ru: 'Активируйте свою учётную запись' },
    'Recuperar contraseña': { pt: 'Recuperar senha', en: 'Recover password', ru: 'Восстановить пароль' },
    'Tu cuenta aún no tiene contraseña. Te enviamos un código a tu correo para que crees la tuya.': {
        pt: 'Sua conta ainda não tem senha. Enviamos um código para o seu e-mail para que você crie a sua.',
        en: 'Your account does not have a password yet. We sent a code to your email so you can create one.',
        ru: 'У вашей учётной записи ещё нет пароля. Мы отправили код на вашу почту, чтобы вы могли его создать.',
    },
    'Te enviamos un código al correo de tu cuenta para crear una contraseña nueva.': {
        pt: 'Enviamos um código para o e-mail da sua conta para criar uma nova senha.',
        en: 'We sent a code to your account email so you can create a new password.',
        ru: 'Мы отправили код на почту вашей учётной записи для создания нового пароля.',
    },
    'Código de 6 dígitos': { pt: 'Código de 6 dígitos', en: '6-digit code', ru: '6-значный код' },
    'Nueva contraseña (mínimo 8)': { pt: 'Nova senha (mínimo 8 caracteres)', en: 'New password (minimum 8)', ru: 'Новый пароль (минимум 8)' },
    'Repetí la contraseña': { pt: 'Repita a senha', en: 'Repeat the password', ru: 'Повторите пароль' },
    'Enviarme el código': { pt: 'Enviar o código', en: 'Send me the code', ru: 'Отправить мне код' },
    'Volver al ingreso': { pt: 'Voltar ao login', en: 'Back to sign in', ru: 'Вернуться ко входу' },
    'Ingresá un correo válido': { pt: 'Informe um e-mail válido', en: 'Enter a valid email', ru: 'Введите действительный адрес электронной почты' },
    'Si el correo corresponde a una cuenta, te llegó un código (revisá spam).': {
        pt: 'Se o e-mail corresponder a uma conta, você recebeu um código (verifique o spam).',
        en: 'If the email matches an account, you received a code (check spam).',
        ru: 'Если адрес электронной почты соответствует учётной записи, вам пришёл код (проверьте спам).',
    },
    'Guardar contraseña nueva': { pt: 'Salvar nova senha', en: 'Save new password', ru: 'Сохранить новый пароль' },
    'Ingresá el código que te llegó por correo': { pt: 'Informe o código que chegou no seu e-mail', en: 'Enter the code you received by email', ru: 'Введите код, который пришёл вам по почте' },
    'La contraseña debe tener al menos 8 caracteres': { pt: 'A senha deve ter pelo menos 8 caracteres', en: 'The password must be at least 8 characters', ru: 'Пароль должен содержать не менее 8 символов' },
    'No se pudo completar la operación': { pt: 'Não foi possível concluir a operação', en: 'Could not complete the operation', ru: 'Не удалось завершить операцию' },
    '✓ Contraseña lista. Ingresá con tu correo y tu contraseña nueva.': {
        pt: '✓ Senha criada. Entre com seu e-mail e sua nova senha.',
        en: '✓ Password ready. Sign in with your email and your new password.',
        ru: '✓ Пароль готов. Войдите, используя свою почту и новый пароль.',
    },

    // ── Modal de alertas ─────────────────────────────────────────────────────
    'Configuración de Alertas': { pt: 'Configuração de Alertas', en: 'Alert Settings', ru: 'Настройки оповещений' },

    // ── Tab de juegos (carga dinámica) ───────────────────────────────────────
    'Error cargando juegos': { pt: 'Erro ao carregar jogos', en: 'Error loading games', ru: 'Ошибка загрузки игр' },

    // ── ConfirmacionDestructiva — template estático ──────────────────────────
    'Confirmar acción': { pt: 'Confirmar ação', en: 'Confirm action', ru: 'Подтвердить действие' },
    // Default de etiquetaAccion cuando el caller no lo especifica
    // "Escribí <strong>X</strong> para confirmar:" se parte en segmentos estáticos
    'Escribí': { pt: 'Digite', en: 'Type', ru: 'Введите' },
    'para confirmar:': { pt: 'para confirmar:', en: 'to confirm:', ru: 'для подтверждения:' },
};
